import { defaultEmbedContextOptions, EmbedContext, } from '@thoughtspot/blink-context';
import { useTranslation } from '@thoughtspot/i18n';
import { Divider } from '@thoughtspot/radiant-react/widgets/divider';
import { Horizontal, Vertical, } from '@thoughtspot/radiant-react/widgets/layout';
import { LoadingIndicator } from '@thoughtspot/radiant-react/widgets/loading-indicator';
import React, { useEffect, useMemo } from 'react';
import { useAdminContext } from "../../../contexts/context";
import { PinboardContextType } from "../../../services/generated/graphql-types";
import { useGetClusterInfoQuery, useGetListSnapshotsQuery, useGetStatsQuery, } from "../../../services/system/cluster-detail-service/cluster-detail-service";
import { create } from "../../../utils/logger";
import { Header, WithQueryHandler } from '../common';
import { ClusterDetailsTable } from './cluster-details-tables/cluster-details.container';
import { ClusterLogsTable } from './cluster-logs-tables/cluster-logs.container';
import { ClusterSnapshotTable } from './cluster-snapshot-tables/cluster-snapshot.container';
import styles from './cluster-status.module.scss';
import { ClusterSummaryCard } from './cluster-summary-card/cluster-summary.container';
const CLUSTERSTATUS_PINBOARD_ID = 'f43e3f57-859f-4665-ac78-82ea72ec0980';
const logger = create('Admin.ClusterStatus');
export const ClusterContainer = () => {
    const { t } = useTranslation();
    const { getStats, data: statsData, loading: isStatsDataLoading, } = useGetStatsQuery();
    const { getClusterInfo, data: clusterInfoData, loading: isClusterInfoDataLoading, } = useGetClusterInfoQuery();
    const { getListSnapshots, data: listSnapshotData, loading: isListSnapshotDataLoading, } = useGetListSnapshotsQuery();
    const { blinkComponents } = useAdminContext();
    const LiveboardContainer = blinkComponents?.LiveboardContainer;
    const embedConfig = useMemo(() => ({
        ...defaultEmbedContextOptions,
        isEmbedded: true,
        isPoweredFooterHidden: true,
        embedParams: {
            ...defaultEmbedContextOptions.embedParams,
            hideLiveboardHeader: true,
            hideTabPanel: true,
        },
    }), []);
    useEffect(() => {
        getStats();
        getClusterInfo();
        getListSnapshots();
    }, []);
    if (isStatsDataLoading ||
        isClusterInfoDataLoading ||
        isListSnapshotDataLoading) {
        return React.createElement(LoadingIndicator, null);
    }
    if (!LiveboardContainer) {
        logger.error('ClusterStatus: LiveboardContainer is not available in blinkComponents context');
    }
    const renderContent = () => (React.createElement(Vertical, { className: styles.clusterTabContainer, "data-testid": "cluster-tab-container" },
        React.createElement(Header, { title: t('system.cluster.title'), titleSize: "large", isFullWidth: true }),
        React.createElement(Divider, null),
        React.createElement(Horizontal, { className: styles.clusterStatusBody },
            statsData && clusterInfoData && (React.createElement(ClusterDetailsTable, { statsData: statsData, clusterInfoData: clusterInfoData })),
            listSnapshotData && (React.createElement(ClusterSnapshotTable, { listSnapshotData: listSnapshotData }))),
        React.createElement(Horizontal, { className: styles.clusterStatusBody },
            statsData && React.createElement(ClusterSummaryCard, { statsData: statsData }),
            statsData && React.createElement(ClusterLogsTable, { statsData: statsData })),
        LiveboardContainer && (React.createElement(Vertical, { className: styles.embedBody },
            React.createElement(EmbedContext.Provider, { value: embedConfig },
                React.createElement("div", { className: styles.liveboardEmbed },
                    React.createElement(LiveboardContainer, { pinboardId: CLUSTERSTATUS_PINBOARD_ID, pinboardContext: PinboardContextType.AdminPinboard })))))));
    return renderContent();
};
export const Cluster = () => {
    return (React.createElement(WithQueryHandler, null,
        React.createElement(ClusterContainer, null)));
};
//# sourceMappingURL=cluster-status.container.js.map